import { RefObject } from 'react'

export const removeExtraSpaces = (value: string) =>
  value.replace(/\s\s+/g, ' ').trim()

export const getIsTextChanged = (currentTextValue: string, value: string) => {
  const newTextValue = removeExtraSpaces(value)
  const isTextEmpty = newTextValue.length === 0
  return currentTextValue !== newTextValue && !isTextEmpty
}

export const scrollToTopTextAreaText = (
  textAreaRef?: RefObject<HTMLTextAreaElement | null>
) => {
  if (textAreaRef?.current) {
    if (textAreaRef.current) {
      textAreaRef.current.scrollTo({
        top: 0
      })
      textAreaRef.current.style.overflowY = 'hidden'
    }
  }
}
